import React from "react";
import { FixedSizeList } from "react-window";
import styled from "styled-components";

const EmptyState = styled.div`
  color: ${props => props.theme["$gray-5"]};
  padding: 2em;
`;

const MenuList = ({ options, children, maxHeight, getValue }) => {
  const [value] = getValue();
  const initialOffset = options.indexOf(value) * 35;

  if (!children.length) {
    return <EmptyState>No options yet!</EmptyState>;
  }

  const flatOptions = children.reduce(
    (acc, { props: { children, ...props }, ...item }) =>
      acc.concat([{ ...item, props }].concat(children)),
    []
  );

  return (
    <FixedSizeList
      height={maxHeight}
      itemCount={flatOptions.length}
      itemSize={35}
      initialScrollOffset={initialOffset}
    >
      {({ index, style }) => <div style={style}>{flatOptions[index]}</div>}
    </FixedSizeList>
  );
};

export default MenuList;
